import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from '../../util/reactIntl';
import { TbPencil } from 'react-icons/tb';
import { AiOutlinePlus } from 'react-icons/ai';
import { BsPinAngle, BsPinAngleFill } from 'react-icons/bs';
import css from './ProfileSettingsTile.css';

const ProfileSettingsTile = props => {
  const {
    id,
    titleId,
    hasContent,
    onEdit,
    onAdd,
    addLink,
    showAddWhenFilled,
    showPinIcon,
    onPinClick,
    isPinActive,
    scorePill,
    children,
  } = props;

  const editPenButton =
    hasContent && onEdit ? (
      <button type="button" className={css.editPen} onClick={onEdit}>
        <TbPencil className={css.editPenIcon} />
      </button>
    ) : null;

  const addButtonContent = (
    <>
      <span className={css.addButtonText}>
        <FormattedMessage id="ProfileSettingsPage.addButton" />
      </span>
      <AiOutlinePlus className={css.addButtonIcon} />
    </>
  );

  const showAdd = !hasContent || showAddWhenFilled;
  const addButtonElement = showAdd
    ? addLink ||
      (onAdd || onEdit ? (
        <button type="button" className={css.addButton} onClick={onAdd || onEdit}>
          {addButtonContent}
        </button>
      ) : null)
    : null;

  const PinIcon = isPinActive ? BsPinAngleFill : BsPinAngle;
  const pinIconElement =
    showPinIcon && hasContent ? (
      onPinClick ? (
        <button
          type="button"
          className={`${css.pinButton} ${isPinActive ? css.pinButtonActive : ''}`}
          onClick={onPinClick}
          aria-pressed={isPinActive}
        >
          <PinIcon className={css.pinIcon} />
        </button>
      ) : (
        <PinIcon className={css.pinIcon} />
      )
    ) : null;

  return (
    <div id={id} className={css.root}>
      <div className={css.header}>
        <h3 className={css.title}>
          <FormattedMessage id={titleId} />
        </h3>
        <div className={css.actions}>
          {addButtonElement ? scorePill : null}
          {pinIconElement}
          {addButtonElement}
          {editPenButton}
        </div>
      </div>
      {hasContent && children ? <div className={css.content}>{children}</div> : null}
    </div>
  );
};

ProfileSettingsTile.defaultProps = {
  hasContent: false,
  onEdit: null,
  onAdd: null,
  addLink: null,
  showAddWhenFilled: false,
  showPinIcon: false,
  onPinClick: null,
  isPinActive: false,
  scorePill: null,
  children: null,
};

ProfileSettingsTile.propTypes = {
  id: PropTypes.string.isRequired,
  titleId: PropTypes.string.isRequired,
  hasContent: PropTypes.bool,
  onEdit: PropTypes.func,
  onAdd: PropTypes.func,
  addLink: PropTypes.node,
  showAddWhenFilled: PropTypes.bool,
  showPinIcon: PropTypes.bool,
  onPinClick: PropTypes.func,
  isPinActive: PropTypes.bool,
  scorePill: PropTypes.node,
  children: PropTypes.node,
};

export default ProfileSettingsTile;
